import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
interface Props {
  compact?: boolean
  centered?: boolean
  right?: boolean
  short?: boolean
  wrap?: boolean
  secondary?: boolean
  colspan?: number
  width?: number
}

export default function TableHeadCell({
  children,
  compact,
  centered,
  right,
  wrap,
  short,
  secondary,
  colspan = 1,
  width,
}: React.PropsWithChildren<Props>) {
  return (
    <th
      className={cx('th', {
        wrap,
        short,
        centered,
        right,
        compact,
        secondary,
      })}
      colSpan={colspan}
      style={{
        width,
      }}
    >
      {children}
    </th>
  )
}
